let chartModulePromise: Promise<typeof import('chart.js')> | undefined

function loadChartModule() {
  if (!chartModulePromise) {
    chartModulePromise = import('chart.js').then((chartModule) => {
      chartModule.Chart.register(...chartModule.registerables)
      return chartModule
    })
  }

  return chartModulePromise
}

export const AdminChartHook: {
  el?: HTMLCanvasElement
  chart: import('chart.js').Chart | null
  isDestroyed?: boolean
  mounted: () => void
  updated: () => void
  destroyed: () => void
  renderChart: () => void
} = {
  chart: null,

  mounted() {
    this.renderChart()
  },

  updated() {
    this.renderChart()
  },

  destroyed() {
    this.isDestroyed = true

    if (this.chart) {
      this.chart.destroy()
    }
  },

  renderChart() {
    if (!this.el) {
      return
    }

    const chartType = this.el.getAttribute('data-chart-type')
    const chartData = this.el.getAttribute('data-chart-data')

    if (!chartType || !chartData) {
      return
    }

    void loadChartModule()
      .then(({ Chart }) => {
        if (this.isDestroyed || !this.el) {
          return
        }

        // The chart from the previous render is destroyed here (not in
        // updated()) so the destroy/create pair stays ordered when the module
        // load resolves asynchronously.
        if (this.chart) {
          this.chart.destroy()
        }

        try {
          const data = JSON.parse(chartData)

          this.chart = new Chart(this.el, {
            type: chartType as any,
            data: data,
            options: {
              responsive: true,
              maintainAspectRatio: false,
              interaction: {
                mode: 'index',
                intersect: false,
              },
              plugins: {
                legend: {
                  display: true,
                  position: 'top',
                },
                // datalabels is registered globally in admin.ts and would
                // otherwise print a number on every point
                datalabels: {
                  display: false,
                },
              },
            },
          })
        } catch (error) {
          console.error('[AdminChartHook] Failed to render chart:', error)
        }
      })
      .catch((error) => {
        console.error('[AdminChartHook] Failed to load chart.js:', error)
      })
  },
}
